import React from 'react';
import { isRtl } from 'modules/language/selectors/language';
import { Input } from 'shared/components';
import theme from './TextSearch.scss';

const TextSearch = ({ textSearch, setTextSearch }) => (
  <Input
    testId="appointment-search-filter"
    value={ textSearch }
    onChange={ setTextSearch }
    isControlled={ false }
    rootClassName={ theme.searchInputContainer }
    wrapperClassName={ theme.input }
    className={ theme.searchInput }
    ariaLabel={{ id: 'Appointments.AppointmentsList.Search.Placeholder', defaultMessage: '** Search appointments' }}
    placeholder={{ id: 'Appointments.AppointmentsList.Search.Placeholder', defaultMessage: '** Search appointments' }}
    isRtl={ isRtl() }
  />
);

export default TextSearch;
